import React, { useRef, useEffect, useState  }  from 'react';
import classes from './VideoSection.module.scss';
import globalJson from 'data/content.json';
import { getFileName } from 'helpers/FileCaching';
import ScrollMagic from 'scrollmagic';
import TimelineMax from "gsap/TimelineMax";
import { TweenMax, Power3} from 'gsap';
import Carousel from "react-spring-3d-carousel";
import Hammer from 'react-hammerjs';
import { config } from "react-spring";


const videoImages = require.context('assets/images/VideoSection', true, /.*\.(gif|png|jpe?g|svg)$/i);
const layoutImages = require.context('assets/images/global/layout', true, /.*\.(gif|png|jpe?g|svg)$/i);
const iconsImages = require.context('assets/images/global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);

const VideoSection = (props) => {
    const [currentSlide, setCurrentSlide] = useState(0); // initialize state
    const [progressPercent, setProgressPercent] = useState("0%"); // initialize state
    const [showArrows, setShowArrows] = useState('0');
    const [showCarousel, setShowCarousel] = useState('block');

    //Configure scroll magic
    let scrollMagicController = useRef(new ScrollMagic.Controller())
    let scrollMagicScene = useRef(new ScrollMagic.Scene({
                                    triggerHook:0.7
                                }).addTo(scrollMagicController.current)
                            )
    
    //TimelineGraphic variables
    let container = useRef();
    let dot = useRef();
    let line = useRef();
    let play = useRef();
    let oval = useRef();

    let text1 = useRef();
    let text2 = useRef();
    let text3 = useRef();

    let videoContent = useRef();
    let carousel = useRef();

    let timelineFeatured_tl = useRef(new TimelineMax({paused:true}));
    timelineFeatured_tl.current.timeScale(2);
    
    let video_tl = useRef(new TimelineMax({paused:true}));
    let markup;

    const configureScrollMagic = () => {

        scrollMagicScene.current.triggerElement(container.current);
        scrollMagicScene.current.duration((container.current.clientHeight));
        scrollMagicScene.current.triggerHook(0.7);
        scrollMagicScene.current.on("progress", function(event){
            updateTimeline(event.progress);
        })
        scrollMagicScene.current.on("leave", function(event){
        
        })
    }

    const createTimeline = () => {
        TweenMax.set([dot.current, oval.current, play.current],{opacity:0, scale:1})
        TweenMax.set(line.current, {height:0});
      
        timelineFeatured_tl.current.to(dot.current, 0.1, {opacity:1, scale:1.3,ease: Power3.easeOut});
        timelineFeatured_tl.current.to(dot.current, 0.1, {scale:1, ease: Power3.easeOut});
        timelineFeatured_tl.current.to(line.current, 0.6, {height:245, ease: Power3.easeOut});
        timelineFeatured_tl.current.fromTo(oval.current, 0.6, {opacity:0, scale: 0.6},{opacity:1, scale: 1.1, ease: Power3.easeOut});
        timelineFeatured_tl.current.to(oval.current, 0.6,{scale:1, ease: Power3.easeOut});
        timelineFeatured_tl.current.fromTo(play.current, 0.3, {delay:-2, opacity:0, scale: .6},{opacity:1, scale: 1.1, ease: Power3.easeOut});
        timelineFeatured_tl.current.to(play.current, 0.3,{scale:1, ease: Power3.easeOut});
        timelineFeatured_tl.current.fromTo(text1.current, 0.3, {delay:-.5, opacity:0, y:10} ,{opacity:1, y:0, ease: Power3.easeOut});
        timelineFeatured_tl.current.fromTo(text2.current, 0.3, {delay:-0.3, opacity:0, y:10} ,{opacity:1, y:0, ease: Power3.easeOut});
        timelineFeatured_tl.current.fromTo(text3.current, 0.3, {delay:-0.3, opacity:0, y:10} ,{opacity:1, y:0, ease: Power3.easeOut, onComplete:animateCarousel});

        video_tl.current.fromTo(carousel.current, 0.3, {delay:0, opacity:0, y:90} ,{opacity:1, y:0, ease: Power3.easeOut});

    }

    const updateTimeline = (progress) => {
        let timelineLength = timelineFeatured_tl.current.duration();
        let tweenToSeconds = timelineLength*progress
        timelineFeatured_tl.current.tweenTo(tweenToSeconds);
        
    }

    const onPromoVideoSelected = (title)=>{
        window.gtag('event', "Video Reel clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': title+ " video Reel clicked",
			'value':10
          });
    
    }

    const animateCarousel = ()=>{
        video_tl.current.tweenTo();
      
        if (slides.length === 0){
            setShowCarousel('none')
        }else{
            setShowCarousel('block')
        }
        
        if(slides.length > 1){
            setShowArrows('1')
        }else{
            setShowArrows('0')
        }
    }

    useEffect(() => {
        createTimeline();
        configureScrollMagic();
      
    }, []);


    //Markup for all the slides

    const slides = props.content.videos.map((video, index) => {
        if(index === currentSlide){
           markup = <div ref={videoContent} className={classes.VideoSection__videoContent}>

                       <h3 className={`${classes.VideoSection__videoTitle}`} dangerouslySetInnerHTML={{__html:video.title}}></h3>

                       <a onClick={() => onPromoVideoSelected(video.title)} className={`playEpisode`} href={video.url} target='_blank'rel="noopener noreferrer">
                            <span className={`playEpisodeBtn`}>
                                <img  alt="play episode" src={getFileName(iconsImages, 'playEpisode.svg')}/>
                            </span>
                            <span className={`playEpisodeCopy`}>
                                {video.cta}
                            </span>
                        </a>
                    </div> 
        }
        return {
            key:index,
            content: 
            <div>
                <a className={classes.VideoSection__videoLink} onClick={() => onPromoVideoSelected(video.title)} href={video.url} target='_blank'rel="noopener noreferrer">
                    <div className={classes.VideoSection__video} style={
                    {
                        backgroundImage: 'url(' + getFileName(videoImages, video.image) + ')',
                    }
                    }/>
                    <div className={classes.VideoSection__videoIcons}>
                        <img className={classes.VideoSection__videoOval} alt="play icon border" src={getFileName(layoutImages, 'dotted_oval.svg')} />
                        <img className={classes.VideoSection__videoPlay} alt="play icon" src={getFileName(iconsImages, 'play.svg')} />
                    </div>
                </a>
             
            </div>

            
        }
    })

    const handleSwipe = (e) =>{
        if(e.direction === 2){
            onNextClick();
        }else if(e.direction === 4){
            onPrevClick();
        }
    }

    const onNextClick = () => {
        if(currentSlide >= slides.length-1){
            setCurrentSlide(0);
           
        }else{
            setCurrentSlide(currentSlide + 1)
           
        }
       
    }

    const onPrevClick = () => {
        if(currentSlide <= 0){
            setCurrentSlide(slides.length-1)
        }else{
            setCurrentSlide(currentSlide-1)
        }
    }


    const on = (e) =>{
        TweenMax.fromTo(e.target, 0.3, {scale:1, backgroundColor:"#FF7C00", border:"1px solid #FF7C00" }, { delay: 0, scale:1.1,  backgroundColor:"transparent", border:"1px solid #FF7C00",  ease: Power3.easeInOut});
    }
    const off = (e) =>{
        TweenMax.to(e.target, 0.3, {scale:1,  backgroundColor:"#FF7C00", border:"1px solid #FF7C00", ease: Power3.easeInOut})
    }


    useEffect(() => {
        setProgressPercent(String((currentSlide/(slides.length-1)))*100+"%");
    }, [currentSlide, slides.length])

    return (
        <div  className={classes.VideoSection}>
            <div ref={container} className={classes.VideoSection__wrap}>
                <h5 className={`section_title ${classes.VideoSection__headTitle}`}>{globalJson.videoSection.title}</h5>
                <div className={classes.VideoSection__header}>
                    <img alt="dot "ref={dot} className={classes.VideoSection__dot} src={getFileName(layoutImages, 'oval.svg')} />
                    <img alt="line" ref={line} className={classes.VideoSection__dottedLine} src={getFileName(layoutImages, 'dotted_line.svg')} />
                    <div className={classes.VideoSection__playIconWrapper}>
                        <a href={globalJson.videoSection.featuredVideo.url} onClick={() => onPromoVideoSelected(globalJson.videoSection.featuredVideo.title)} target="_blank" rel="noopener noreferrer">
                            <img ref={oval} alt="play icon border" className={classes.VideoSection__dottedOval}  src={getFileName(layoutImages, 'dotted_oval.svg')} />
                            <img ref={play} alt="play icon" className={classes.VideoSection__playIcon} src={getFileName(iconsImages, 'play.svg')} />
                        </a>
                    </div>
                </div>
                <div className={classes.VideoSection__featured}>
                    <div className={classes.VideoSection__featuredImage}
                        style={
                            {
                                backgroundImage: 'url(' + getFileName(videoImages, globalJson.videoSection.featuredVideo.image) + ')'
                            }
                        }>
                    </div>
                    <div className={`row`}>
                        <div className={`${classes.VideoSection__featuredContent}`}>
                            <p ref={text1} className={`subtitle ${classes.VideoSection__featuredSubtitle}`}>{globalJson.videoSection.featuredVideo.subtitle}</p>
                            <h2 ref={text2} className={classes.VideoSection__featuredTitle} dangerouslySetInnerHTML={{__html:globalJson.videoSection.featuredVideo.title}}></h2>
                            <p ref={text3} className={classes.VideoSection__featuredDescription}>{globalJson.videoSection.featuredVideo.description}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div ref={carousel} className={classes.VideoSection__carouselWrapper} style={{display:showCarousel}} >
                <Hammer onSwipe={handleSwipe}>
                    <div id="carouselContainer" className={classes.VideoSection__carousel}>
                        <Carousel
                        slides={slides}
                        goToSlide={currentSlide}
                        offsetRadius={1}
                        showNavigation={false}
                        animationConfig={config.stiff}
                        />
                        <div className={classes.VideoSection__carouselArrowWrapper} style={{opacity:showArrows}} >
                            <div className={classes.VideoSection__prevArrow} onClick={onPrevClick}> 
                                <img alt="prev arrow" src={getFileName(iconsImages, 'backArrowCarousel.svg')} onMouseOver={on} onMouseOut={off} />
                            </div>
                            <div className={classes.VideoSection__nextArrow} onClick={onNextClick}>   
                                <img  alt="next arrow" src={getFileName(iconsImages, 'nextArrowCarousel.svg')}  onMouseOver={on} onMouseOut={off} />
                            </div>
                        </div>
                    </div>
                </Hammer>
                {markup}
                <div className={` ${classes.VideoSection__progressBarWrapper}`}>
                    <div className={classes.VideoSection__divider}></div>
                    <div className={classes.VideoSection__progressBar} style={{width:progressPercent}} onClick={onNextClick}></div>
                </div>
                
            </div>
        </div>
       );
};

export default VideoSection;